import { store } from './react-initialize';
import * as HeaderActions from './Header/actions';
import { TopicSelector } from './topic_selector';

const WorkbenchManager = {
   addItem: function (topicVariantid, wikiid, useIndicator, topicTitle) {
      topicTitle = topicTitle ? topicTitle : null;
      let request = new Request.API_2_0('user/workbench/add?langid=' + App.lang, {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
         topicTitle: topicTitle,
         productcode: App.productcode,
      });

      request.done(function (result) {
         /* Add the html to workbench */
         if (result) {
            // With the Hydra header, we're storing the topics in
            // Redux so that whenever it changes, the React dropdown can
            // re-render.
            store.dispatch(HeaderActions.updateWorkbench(result.topics));

            if (topicVariantid) {
               WorkbenchManager.removeItem(null, wikiid, /* useIndicator */ false);
            }
         }
         /* Remove variant devices if generic is checked */
         if (!topicVariantid) {
            TopicSelector.deselectVariantItems(wikiid);
         }
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Adding'),
            successMessage: _js('Added'),
         });
      }
   },

   removeItem: function (topicVariantid, wikiid, useIndicator) {
      let request = new Request.API_2_0('user/workbench/remove?langid=' + App.lang, {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });

      request.done(function (response) {
         store.dispatch(HeaderActions.updateWorkbench(response.topics));
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Removing'),
            successMessage: _js('Removed'),
         });
      }
   },

   setActiveItem: function (dropdownId) {
      dropdownId = dropdownId.split('-');
      let wikiid = parseInt(dropdownId[0], 10);
      let topicVariantid = dropdownId[1];

      let request = new Request.API_2_0('user/workbench/set_active', {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });

      request.done(function (response) {
         store.dispatch(HeaderActions.updateWorkbench(response.topics));
      });
   },

   getCurrentWorkbench: function () {
      let request = new Request.API_2_0('user/workbench/', {
         method: 'GET',
      }).send();

      request.done(function (response) {
         store.dispatch(HeaderActions.updateWorkbench(response.topics));
      });
   },
};

export default WorkbenchManager;
